export default __webpack_public_path__ + "static/media/stewardship-gray.054f1737.svg";